import { GridColDef, GridRowParams } from "@mui/x-data-grid";
import { useTranslation } from "react-i18next";
import { Table } from "@4uhub/lib4uhub";

import MainApiService from "../../../services/mainApi.service";
import { Chip } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { IMyTotens } from "../../../models/totem";

const MY_APPS_ROUTE =
  process.env.REACT_APP_MAIN +
  "/api/v1/SiteApp/GetAllMySiteAppsWithPaginationTotem/";
const myAppsService = new MainApiService<IMyTotens>(MY_APPS_ROUTE);

const translationPath = "page.register.totem.";

const MyTotemPage = () => {
  const navigate = useNavigate();

  const { t } = useTranslation();

  const columns: GridColDef<IMyTotens>[] = [
    {
      field: "name",
      headerName: t(translationPath + "name") || "Name",
    },
    {
      field: "siteAppType",
      headerName: t(translationPath + "type") || "Type",
      renderCell: (params) => {
        return params.value ? params.value.name : "-";
      },
    },
    {
      field: "siteAppStatus",
      headerName: t(translationPath + "status") || "Status",
      maxWidth: 150,
      renderCell: (params) => {
        return (
          <Chip
            size="small"
            color={params.value ? "success" : "error"}
            label={
              params.value
                ? t(translationPath + "active")
                : t(translationPath + "inactive")
            }
          />
        );
      },
    },
  ];

  const handleRowClick = (params: GridRowParams<IMyTotens>) => {
    navigate(`${params.id.toString()}/edit`);
  };

  return (
    <Table<IMyTotens>
      showDefaultMacroFilters={false}
      service={myAppsService}
      columns={columns}
      title={t(translationPath + "my_totems")}
      searchInput
      onRowClick={handleRowClick}
      showButton={false}
      showDeleteButton={false}
      defaultActions={false}
      searchInputPlaceHolder={
        t(translationPath + "search") || "Search for a totem"
      }
      confirmOptions={{
        title: t(translationPath + "confirm.title"),
        description: t(translationPath + "confirm.description"),
        confirmationButtonProps: {
          variant: "contained",
        },
      }}
    />
  );
};

export default MyTotemPage;
